import type { ParameterDimensionDefinitionInOut } from '@festina/configuration-general-types/configuration'
import type { FPlusLiteralType } from '@festina-life/fplus-monaco'

export const AddParameterDefinitionDimensionPlaceholder = Symbol(
  'AddParameterDefinitionDimensionPlaceholder',
)

export type ParameterDimensionDefinitionRowData =
  | ParameterDimensionDefinitionInOut
  | typeof AddParameterDefinitionDimensionPlaceholder

export const isAddParameterDefinitionDimensionPlaceholder = (
  data: ParameterDimensionDefinitionRowData,
): data is typeof AddParameterDefinitionDimensionPlaceholder =>
  data === AddParameterDefinitionDimensionPlaceholder

// Platform has removed these types from the configuration types but still requires them for validation. We therefore
// provide them in the frontend for now. In the future they might be reintroduced by the platform.
export const ParameterDimensionOptions = ['stringType', 'integerType'] as const
export type ParameterDimensionType = (typeof ParameterDimensionOptions)[number]

export const ParameterDimensionTypeToLiteralExpressionType: Record<
  ParameterDimensionType,
  FPlusLiteralType
> = {
  integerType: 'integer',
  stringType: 'string',
}
